import { Testimonial } from '../types/testimonial';

export const TESTIMONIALS: Testimonial[] = [
  {
    videoId: 'ydz00oan2l',
    quote:
      '“Flexcar has been by far the best financial option for me, and I love the flexibility.”',
    name: 'Sarah P',
    posterImageURL:
      'https://embed-ssl.wistia.com/deliveries/a9dee833f2ce793785fdf02f39feedcbc5f12742.jpg',
  },
  {
    videoId: 'wkjnzdau3g',
    quote: '“Flexcar has no down payment or hidden charges, and insurance was included.”',
    name: 'Vivesh G',
  },
  {
    videoId: 'zvaxlj2dpc',
    quote: '“Flexcar saves me money and I can cancel anytime with no questions asked.”',
    name: 'Nick N',
  },
  {
    videoId: 'jvli3iz907',
    quote:
      '“Flexcar beats buying or leasing because it takes the hassle out of owning a car.”',
    name: 'Sarah M',
  },
];
